export default __webpack_public_path__ + "static/media/gearing.94865b27.png";